export default __webpack_public_path__ + "static/media/NABICIE_PUNKTOW.26a6bfd7.gif";